import moment, { Moment } from "moment";

export type SocialCalendarFetchView = "day" | "week" | "month";

/**
 * Rango que cubre vista actual + mismo ancho que el historial (mes actual y siguiente en redacción social)
 * y un margen futuro, para que addMany del store no deje huecos si el programa queda fuera del mes visible.
 */
export function getUnifiedSocialCalendarPostRange(params: {
  calendarView: SocialCalendarFetchView;
  date: Moment;
}): { since: string; until: string } {
  const { calendarView, date } = params;
  const rangeStart =
    calendarView === "day"
      ? moment(date).startOf("day")
      : calendarView === "week"
      ? moment(date).startOf("week")
      : moment(date).startOf("month");
  const rangeEnd =
    calendarView === "day"
      ? moment(date).endOf("day")
      : calendarView === "week"
      ? moment(date).endOf("week")
      : moment(date).endOf("month");

  const histStart = moment().startOf("month");
  const histEnd = moment().add(1, "month").endOf("month");
  const futureCap = rangeEnd.clone().add(12, "months");

  return {
    since: moment.min(rangeStart, histStart).format("YYYY-MM-DD"),
    until: moment.max(rangeEnd, histEnd, futureCap).format("YYYY-MM-DD"),
  };
}
